// extracted by mini-css-extract-plugin
export default {"socialLinks":"SJ0iPNG","socialLink":"st34raq","link":"cYGKXSQ","srOnly":"HURX2dz AQi6YMD"};